import React from 'react';

interface TrimmerTrackProps {
    containerRef: React.RefObject<HTMLDivElement | null>;
    thumbnails: string[];
    displayCount: number;
    leftPosition: number;
    rightPosition: number;
    containerWidth: number;
}

export function TrimmerTrack({
    containerRef,
    thumbnails,
    displayCount,
    leftPosition,
    rightPosition,
    containerWidth,
}: TrimmerTrackProps) {
    return (
        <div
            ref={containerRef}
            className="relative w-full h-8 bg-grey-600 overflow-hidden rounded-[2px]"
        >
            <div className="flex h-full">
                {thumbnails.map((thumbnail, index) => (
                    <div
                        key={index}
                        className="flex-shrink-0 h-full"
                        style={{ width: `${100 / displayCount}%` }}
                    >
                        <img
                            src={thumbnail}
                            alt={`Thumbnail ${index}`}
                            className="w-full h-full object-cover"
                        />
                    </div>
                ))}
            </div>
            <div
                className="absolute top-0 bottom-0 bg-black/40 pointer-events-none"
                style={{
                    left: 0,
                    width: `${leftPosition}px`,
                }}
            />
            <div
                className="absolute top-0 bottom-0 bg-black/40 pointer-events-none"
                style={{
                    left: `${rightPosition}px`,
                    width: `${containerWidth - rightPosition}px`,
                }}
            />
            <div
                className="absolute top-0 bottom-0 border-2 border-white rounded-l-[4px] rounded-r-[4px] pointer-events-none"
                style={{
                    left: `${leftPosition}px`,
                    width: `${rightPosition - leftPosition}px`,
                }}
            />
        </div>
    );
}
